var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.223 8.584.172-.395a3.04 3.04 0 0 1 1.549-1.571l.53-.236a.37.37 0 0 0 0-.672l-.5-.223a3.05 3.05 0 0 1-1.572-1.623l-.177-.427a.353.353 0 0 0-.656 0l-.177.427a3.05 3.05 0 0 1-1.571 1.623l-.5.223a.37.37 0 0 0 0 .672l.53.236c.689.306 1.241.867 1.548 1.57l.172.396a.353.353 0 0 0 .652 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.882 5.642a5.027 5.027 0 0 0 6.254 4.874v10.27H4.31V5.424h7.577a5 5 0 0 0-.006.218M8.151 16.945h6.145V15.41H8.15zm0-3.072h6.145v-1.536H8.15zm0-3.072h2.304V9.265H8.151z",
    clipRule: "evenodd"
  })));
};
export default SvgNews;